import React from "react";
import { handleEnterPress } from "component-library";

import { heapTrackingForEditPanel } from "app/helpers/heapTracking";
import "./EditPanel.scss";

export interface IEditPanelProps {
  header: string;
  editFn: () => void;
  hideEdit?: boolean;
  additionalControls?: React.ReactNode[];
  editLinkAltText?: string;
}

export const EditPanel: React.FC<React.PropsWithChildren<IEditPanelProps>> = (
  props
) => {
  const {
    header,
    editFn,
    hideEdit,
    additionalControls = [],
    editLinkAltText,
  } = props;

  return (
    <div className="c-edit-panel">
      <h4 className="c-edit-panel__header">{header}</h4>
      <div className="c-edit-panel__controls">
        {!hideEdit && (
          <a
            className="c-edit-panel__edit icon-edit"
            onClick={() => {
              heapTrackingForEditPanel();

              editFn();
            }}
            tabIndex={0}
            onKeyPress={handleEnterPress(editFn)}
            aria-label={`${editLinkAltText} ${header}`}
            role="button"
          />
        )}
        {additionalControls.length > 0 && (
          <div className="c-edit-panel__additional-controls">
            {additionalControls}
          </div>
        )}
      </div>
    </div>
  );
};
